export default {
    slug: 'invoices',
    prefix: 'billing',
    title: 'Invoices',
    visible: [
        'invoice_number',
        'contact.customer_number',
        'contact.full_name',
        'sum_after_tax',
        'status',
        'subject',
        'rsvp_ids'
    ],
    templates: {
        sum_after_tax(row) {
            return parseFloat(row.sum_after_tax ? row.sum_after_tax : 0).toFixed(2) + ' €';
        },
        shipping_costs(row) {
            return parseFloat(row.shipping_costs ? row.shipping_costs : 0).toFixed(2) + ' €';
        },
        processing_costs_sum(row) {
            return parseFloat(row.processing_costs_sum ? row.processing_costs_sum : 0).toFixed(2) + ' €';
        },
        rsvp_ids(row) {
            let out = '',
                isFirst = true;

            _.each(row.rsvp_ids, (value) => {
                if (!isFirst) {
                    out += ', ';
                }

                out += value.rsvp_id;

                isFirst = false;
            });

            return out;
        },
        booking_numbers(row) {
            let out = '',
                isFirst = true;

            _.each(row.booking_numbers, (value) => {
                if (!isFirst) {
                    out += ', ';
                }

                out += value.booking_number;

                isFirst = false;
            });

            return out;
        }
    },
    listview: 'InvoicesListView',
    locales: ['common'],
    actions: {
        // create: {
        //     title: 'Add new',
        //     level: 'highlight',
        //     icon: 'plus-circle',
        //     vm: 'addNew'
        // },
        details: {
            title: 'Details',
            level: 'row',
            vm: 'showDetails'
        },
    }
}



// WEBPACK FOOTER //
// ./src/app/store/billing/invoices/state.js